import { http } from "./api-config";
import myApp from "../main";
import store from "../store";

const apiDocumentClient = http(process.env.VUE_APP_DOCUMENT_SERVICE)

export default {
    async getDocumentsById(id) {
        const res = await apiDocumentClient.get(`documents/${id}`)
        return res.data
    },
    async getBlobDocumentById(id) {
        const res = await apiDocumentClient.get(`documents/${id}`, { responseType: "blob" })
        return res.data
    },
    async createDocuments(data) {
        const headers = { 'Content-Type': 'multipart/form-data' }
        const res = await apiDocumentClient.post('documents', data, { headers })
        return res.data
    },
    async createChatDocuments(data) {
        const headers = { 'Content-Type': 'multipart/form-data' }
        const res = await apiDocumentClient.post('chat_documents', data, { headers })
        return res.data
    },
    async deleteDocuments(id) {
        const res = await apiDocumentClient.delete(`documents/${id}`)
        return res.data
    },
    async getDocumentsByMeetingId(id) {
        const res = await apiDocumentClient.get(`meetingdocuments/${id}`)
        return res.data
    },
    async getDocumentsByAgendaId(id) {
        const res = await apiDocumentClient.get(`agendadocuments/${id}`)
        return res.data
    },

    async getAgendaListForDocument() {
        let headers = {};
        if (store.state.variables.cashAgendaListForDocument) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashAgendaListForDocument', true)
        const res = await apiDocumentClient.get('agendalistfordoc', { headers })
        return res.data
    },

    async getMeetingListForDocument(data = null) {
        const filter = data && data.filter_type === 'custom'
            ? { filter_type: data.filter_type, from: data.start_date, to: data.end_date }
            : data && data.filter_type
                ? { filter_type: data.filter_type }
                : {};
        let headers = {};
        if (store.state.variables.cashMeetingListForDocument) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashMeetingListForDocument', true)
        const res = await apiDocumentClient.get('meetinglistfordoc', { params: filter, headers })
        return res.data
    },

    async getDirectoryList() {
        const res = await apiDocumentClient.get('directorylist')
        return res.data
    },

    async downloadDocument(id, filename) {
        try {

            const res = await apiDocumentClient.get(`documents/${id}`, {
                responseType: "blob",
                fileName: filename,
            })
            return res
        } catch (error) {
            let responseResult = await error.response.data.text();
            const responseObj = JSON.parse(responseResult)
            const firstDigitStr = String(error.response.status)[0];
            if (Number(firstDigitStr) === 4) {
                myApp.$store.commit('setAPIErrorMessage', responseObj.error_message)
            }
            return Promise.reject(error);
        }

    },

    async getMeetingDocumentViews(meeting_id, user_email) {
        let headers = {};
        if (store.state.variables.cashMeetingId === meeting_id && store.state.variables.cashUserEmail === user_email) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashMeetingId', meeting_id)
        store.commit('variables/setCashUserEmail', user_email)
        const res = await apiDocumentClient.get(`documentactivitylogs?meetingid=${meeting_id}&useremail=${user_email}`, { headers })
        return res.data
    },
    async getLandingPageDocumentsList() {
        let headers = {};
        if (store.state.variables.cashedDocumentsList) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashedDocumentsList', true)
        const res = await apiDocumentClient.get('landingpagewidgets', { headers })
        return res.data.data
    },
    async getLandingPageDocumentById(id) {
        const res = await apiDocumentClient.get(`landingpagewidgets/${id}`)
        return res.data.data
    },
    async createLandingPageDocument(data) {
        const res = await apiDocumentClient.post('landingpagewidget', data)
        return res.data.data
    },
    async updateLandingPageDocument(data) {
        const res = await apiDocumentClient.put('landingpagewidget', data)
        return res.data.data
    },
    async deleteLandingPageDocument(id) {
        const res = await apiDocumentClient.delete(`landingpagewidgets/${id}`)
        return res.data.status
    }
}